<p
    *ngIf="
        field.invalid && (field.touched || field.dirty) && field.errors.required
    "
    class="invalid-feedback"
>
    Ce champ est requis
</p>
